<template>
  <md-empty-state
    :md-icon="icon"
    :md-label="customLabel ? customLabel : emptyStateLabel"
    class="color-blue"
    :md-description="customDescription ? customDescription : description"
    :md-rounded="mdRounded"
  >
    <md-button
      v-if="buttonLabel || buttonIcon"
      @click="click"
      class="md-primary md-raised"
    >
      <md-icon v-if="buttonIcon" style="color: var(--white) !important">
        {{ buttonIcon }}
      </md-icon>

      {{ buttonLabel }}
    </md-button>
  </md-empty-state>
</template>

<script>
/*
  Use: in component:  EmptyStates: require('@/customcontrols/emptyStates.vue').default,
  <div v-else class="md-layout-item md-size-100">
    <EmptyStates stateType="data" />
  </div>
  */
export default {
  name: "EmptyStateCore",
  components: {},
  props: {
    stateType: {
      type: String,
      default: "data",
    },
    label: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
    buttonLabel: {
      type: String,
      defualt: null,
    },
    buttonIcon: {
      type: String,
      defualt: null,
    },
    customLabel: {
      type: String,
      defualt: null,
    },
    customDescription: {
      type: String,
      defualt: null,
    },
    mdRounded: {
      type: Boolean,
      defualt: false,
    },
  },
  data: function () {
    return {};
  },
  computed: {
    icon: function () {
      switch (this.stateType) {
        default:
        case "data":
          return "subtitles_off";

        case "photo":
        case "image":
        case "pic":
        case "picture":
          return "hide_image";
        case "download":
          return "file_download_off";
        case "attachment":
          return "attach_file";
        case "meter":
          return "speed";
        case "receipt":
          return "receipt_long";
        case "payments":
          return "payments";
        case "no_accounts":
          return "no_accounts";
        case "meter":
          return "speed";
      }
    },
    emptyStateLabel: function () {
      if (this.label) return this.label;
      else {
        switch (this.stateType) {
          default:
          case "data":
            return this.$t("common.noDataFound");

          case "photo":
          case "image":
          case "pic":
          case "picture":
            return this.$t("common.NoPhotosFound");
          case "download":
            return this.$t("common.NoFiles");
          case "attachment":
            return this.$t("common.NoAttachments");
          case "no_accounts":
            return this.$t("activities.NoCustomersFound");
          case "meter":
            return this.$t("common.NoMetersFound");
        }
      }
    },
  },
  methods: {
    click(e) {
      //console.log("clicked", e)
      this.$emit("click", e);
    },
  },
};
</script>
<style></style>
